import React, { useState, useEffect } from 'react';
import Mammoth from 'mammoth';
import '../styles/Agreements.css';

const AGREEMENT_PATHS = {
  privacy: '/GizlilikSözleşmesi.docx',
  terms: '/HizmetKoşulları.docx',
  kvkk: '/KVKK.docx'
};

function Agreements() {
  const [activeAgreement, setActiveAgreement] = useState('privacy');
  const [agreements, setAgreements] = useState({
    privacy: { title: 'Gizlilik Sözleşmesi', content: '' },
    terms: { title: 'Hizmet Koşulları', content: '' },
    kvkk: { title: 'KVKK', content: '' }
  });

  useEffect(() => {
    const fetchDocument = async (type) => {
      try {
        const response = await fetch(AGREEMENT_PATHS[type]);
        const arrayBuffer = await response.arrayBuffer();

        // Mammoth ile docx içeriğini işleme
        const result = await Mammoth.convertToHtml({ arrayBuffer });
        setAgreements(prev => ({
          ...prev,
          [type]: { ...prev[type], content: result.value }
        }));
      } catch (error) {
        console.error(`Error loading ${type} document:`, error);
      }
    };

    Object.keys(AGREEMENT_PATHS).forEach(type => fetchDocument(type));
  }, []);

  return (
    <div className="agreements-container">
      <div className="agreements-tabs">
        {Object.keys(agreements).map(type => (
          <button 
            key={type}
            className={`tab-button ${activeAgreement === type ? 'active' : ''}`}
            onClick={() => setActiveAgreement(type)}
          >
            {agreements[type].title}
          </button>
        ))}
      </div>
      
      <div className="agreement-content">
        <h1>{agreements[activeAgreement].title}</h1>
        <div className="content-scroll" dangerouslySetInnerHTML={{ __html: agreements[activeAgreement].content || 'Yükleniyor...' }} />
      </div>
    </div>
  );
}

export default Agreements; 

